export const generateRandomPassword = (length) => {
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const numbers = "0123456789";
  const special = "!@#$%^&*()_+[]{}|;:,.<>?";

  // Ensure we have at least one character from each required set
  let password = "";
  password += uppercase.charAt(Math.floor(Math.random() * uppercase.length));
  password += lowercase.charAt(Math.floor(Math.random() * lowercase.length));
  password += numbers.charAt(Math.floor(Math.random() * numbers.length));
  password += special.charAt(Math.floor(Math.random() * special.length));

  // Fill the rest of the password length with random characters from all sets
  const allCharacters = uppercase + lowercase + numbers + special;
  for (let i = password.length; i < length; i++) {
    password += allCharacters.charAt(
      Math.floor(Math.random() * allCharacters.length)
    );
  }

  // Shuffle the password to ensure random distribution of characters
  password = password
    .split("")
    .sort(() => Math.random() - 0.5)
    .join("");

  return password;
};
